import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fill-height absolute" }
const _hoisted_2 = { class: "text-medium-emphasis font-weight-bold text-h6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: _normalizeClass(["d-flex align-end flex-column default_card elevation-0 fill-height mx-2 overflow-wrap-anywhere", { 'cursor-default': !_ctx.dense }]),
      id: _ctx.cardId,
      outlined: _ctx.dense,
      border: "sm",
      onClick: _ctx.onClickCard
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "px-2 mb-auto fill-height" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "fill-height"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "pb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '12' : '10'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.bankAccountName), 1)
                          ]),
                          _: 1
                        }, 8, ["cols"]),
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              class: "pt-2 pr-2 d-flex justify-end align-baseline text-medium-emphasis font-weight-bold"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.$vuetify.display.sm)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      small: ""
                                    }, {
                                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode("$fa-university")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.$vuetify.display.md)
                                  ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode("$fa-university")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.$vuetify.display.lgAndUp)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 2,
                                      large: ""
                                    }, {
                                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode("$fa-university")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.bankAccount.number)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Numéro : " + _toDisplayString(_ctx.bankAccount.number), 1))
                      : _createCommentVNode("", true),
                    (
                                _ctx.bankAccount.iban && !_ctx.bankAccount.iban.startsWith(_ctx.bankAccount.name)
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " IBAN : " + _toDisplayString(_ctx.bankAccount.iban), 1))
                      : _createCommentVNode("", true),
                    (_ctx.bankAccount.externalName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nom externe : " + _toDisplayString(_ctx.bankAccount.externalName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_icon, { "x-small": "" }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("$fa-upload")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.getImportOrigin()) + " " + _toDisplayString(" - " + _ctx.bankAccount.bankTransactionCount + " transaction(s)"), 1)
                    ]),
                    (_ctx.bankAccount.importStartDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_v_icon, { "x-small": "" }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("$fa-upload")
                            ])),
                            _: 1
                          }),
                          _createTextVNode(" Date de reprise : " + _toDisplayString(_ctx.formatDate(_ctx.bankAccount.importStartDate)) + " " + _toDisplayString(" - " +
                                _ctx.bankAccount.beforeImportStartDateBTCount +
                                " transaction(s) avant"), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.hasError || !_ctx.bankAccount.bic)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "text-color-red"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.hasError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.bankAccount.currentError), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.bankAccount.bic)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_v_icon, {
                                class: "mr-2",
                                color: "red",
                                small: ""
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode(" $oss-warning ")
                                ])),
                                _: 1
                              }),
                              _cache[6] || (_cache[6] = _createElementVNode("div", null, "BIC manquant", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.dense)
          ? (_openBlock(), _createBlock(_component_v_card_actions, {
              key: 0,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.onClickConnect,
                  disabled: !_ctx.canUserEnableBudgetInsight,
                  loading: _ctx.isBankConnecting,
                  variant: "flat",
                  class: "px-4",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.bankAccount.currentError ? "Réparer" : "Configurer"), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "id", "outlined", "onClick"])
  ]))
}